import axios from 'axios';
import qs from 'qs';
import {SAVE_CONTACT, FETCH_PORTFOLIOS, FILTER_PORTFOLIOS} from './types'

export function saveContact(contact){
  console.log(contact);
  const response = axios.post('https://www.gongideas.com/api.php/contact/post', qs.stringify(contact));
  return {
    type: SAVE_CONTACT,
    payload: response
  };
}

export function fetchPortfolios(){
  const response = axios.get('https://www.gongideas.com/api.php/portfolios/get_list');
  return {
    type: FETCH_PORTFOLIOS,
    payload: response
  };
}
export function filterPortfolio(filter){
  return {
    type: FILTER_PORTFOLIOS,
    payload: filter
  };
}


// WEBPACK FOOTER //
// ./src/actions/index.js